import type { Period } from '~/services/types';

export const shortNameCompare = (a: Period, b: Period) => {
  const aStartsWithDigit = /^\d/.test(a.shortName);
  const bStartsWithDigit = /^\d/.test(b.shortName);

  // Separate into two groups: number-first vs letter-first
  if (aStartsWithDigit !== bStartsWithDigit) {
    return aStartsWithDigit ? -1 : 1; // number-first comes before letter-first
  }

  // Within the same group, use natural sort (handles embedded numbers)
  return a.shortName.localeCompare(b.shortName, undefined, {
    numeric: true,
    sensitivity: 'base',
  });
};

export const sortPeriodsByShortName = (periods: Period[]) => {
  return [...periods].sort((a, b) => shortNameCompare(a, b));
};
